// src/components/Image/ImageWithFallback.jsx
import React, { useState } from "react";
import blogFallback from "../../assets/logo-buukkeri-dark.webp"; // ← oma kuva

export default function ImageWithFallback({
  src,
  srcSet,
  sizes,
  alt = "",
  className = "",
  loading = "lazy",
  fallbackSrc = blogFallback,    // ← voit ylikirjoittaa propilla
  width,
  height,
}) {
  // jos src puuttuu, käynnistä suoraan fallbackilla
  const [failed, setFailed] = useState(!src);

  const effectiveSrc   = failed ? fallbackSrc : src;
  const effectiveSet   = failed ? undefined   : srcSet;
  const effectiveSizes = failed ? undefined   : sizes;

  return (
    <img
      src={effectiveSrc}
      srcSet={effectiveSet}
      sizes={effectiveSizes}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      onError={() => setFailed(true)}
      // (valinnaiset, vähentävät CLS:ää jos tiedossa)
      width={width}
      height={height}
    />
  );
}
